export default __webpack_public_path__ + "static/media/R80.1b68fa4f.png";